import { render, staticRenderFns } from "./notesList.vue?vue&type=template&id=837e112e&scoped=true&"
import script from "./notesList.vue?vue&type=script&lang=js&"
export * from "./notesList.vue?vue&type=script&lang=js&"
import style0 from "./notesList.vue?vue&type=style&index=0&id=837e112e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837e112e",
  null
  
)

export default component.exports